
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiResistor5On as ObiResistor5OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-resistor-5-on.js';
 
 
 

 
 export const ObiResistor5On = createComponent({
   react: React,
   tagName: 'obi-resistor-5-on',
   elementClass: ObiResistor5OnElement,
   events: {
     
   }
  });
 
 